import { 
  PageKnowledgeHubLayout, PageKnowledgeHubLayoutProps, SliceBlockGrid, SliceBlockToutGrid, SliceBlockToutGridProps, 
  SliceContactForm, SliceContactFormProps, SliceContent, SliceContentPanel, SliceContentPanelProps, SliceEntityViewAsideMobile, SliceEntityViewAsideMobileProps, SliceIntro, 
  SliceKeyMessage, SliceMarketMapPanel, SlicePersonBioGrid, SlicePersonBioGridProps, SliceQuestion, 
  SliceQuestionProps, SliceViewIntro, createSliceLayout 
} from '@shapeable/ui';
import { RestorationProjectGrid, RestorationProjectGridProps } from '../entities/restoration-project-grid';
import { ContactForm } from '../elements/contact-form';
import { SliceKnowledgeHubIntro } from '../entities/slice-knowledge-hub-intro';
import { SliceMetricsBlocks } from '../entities/slice-metrics-blocks';
import { SliceProtectionChart } from '../entities/slice-protection-chart';
import { SliceRestorationChart } from '../entities/slice-restoration-chart';
import { SliceIntroPledge } from '../entities/slice-intro-pledge';
import { SliceNarrative, SliceNarrativeProps } from '../entities/slice-narrative';
import { SliceMembershipGrid, SliceMembershipGridProps } from '../entities/slice-membership-grid';
import { SLICE_MEMBERSHIP, SLICE_MEMBERSHIP_CONTACT } from '../../data';
import { KelpIcon } from '../icons/kelp-icon';
import { SliceBannerTout, SliceBannerToutProps } from '../entities/slice-banner-tout';
import { SliceEntityStackLink } from '../entities/slice-entity-stack-link';
import { SliceRegionData } from '../entities/slice-region-data';
import { SliceAsideMapLink } from '../entities/slice-aside-map-link';
import { SliceRegionKeyMessage } from '../entities/slice-region-key-message';
import { SliceIndigenousVoicesStorymap } from '../entities/slice-indigenous-voices-storymap';

export const SliceLayoutIndigenousVoicesStorymap = createSliceLayout(
  SliceIndigenousVoicesStorymap, {
    verticalPadding: 'none',
    boundary: 'none',
  }
);

export const SliceLayoutIntroPledge = createSliceLayout(
  SliceIntroPledge, {
    verticalPadding: 'small',
  }
);

export const SliceLayoutKeyMessage = createSliceLayout(
  SliceKeyMessage, {
    verticalPadding: 'large',
    overlayColor: '#00000033',
  }
);

export const SliceLayoutIntro = createSliceLayout(
  SliceIntro, {
    verticalPadding: 'small',
  }
);

export const SliceLayoutMetricsBlocks = createSliceLayout(
  SliceMetricsBlocks, {
    boundary: 'content-bleed',
  }
);

export const SliceLayoutBlockGrid = createSliceLayout(
  SliceBlockGrid, {
    verticalPadding: 'content',
    boundary: 'content',
  }
);

export const SliceLayoutNarrative = createSliceLayout<SliceNarrativeProps>(
  SliceNarrative, {
    verticalPadding: 'small',
  }
);

export const SliceLayoutNarrativeReverse = createSliceLayout<SliceNarrativeProps>(
  SliceNarrative, {
    verticalPadding: 'small',
    props: {
      reverse: true,
    }
  },

);

export const SliceLayoutKnowledgeHubIntro = createSliceLayout(
  SliceKnowledgeHubIntro, {
    verticalPadding: 'content',
  }
);

export const SliceLayoutContactForm = createSliceLayout<SliceContactFormProps>(
  SliceContactForm, {
    verticalPadding: 'small',
    props: {
      formComponent: ContactForm,
      variant: 'inline'
    }
  }
);

export const SliceLayoutRestorationChart = createSliceLayout(
  SliceRestorationChart, {
    boundary: 'content',
    verticalPadding: 'none',
  }
);

export const SliceLayoutProtectionChart = createSliceLayout(
  SliceProtectionChart, {
    boundary: 'content',
    verticalPadding: 'none',
  }
);

export const SliceLayoutMembershipGrid = createSliceLayout<SliceMembershipGridProps>(
  SliceMembershipGrid, {
    boundary: 'none',
    props: {
      blocks: SLICE_MEMBERSHIP.blocks
    }
  }
);


export const SliceLayoutMembershipGridContact = createSliceLayout<SliceMembershipGridProps>(
  SliceMembershipGrid, {
    boundary: 'none',
    props: {
      blocks: SLICE_MEMBERSHIP_CONTACT.blocks
    }
  }
);

export const SliceLayoutPersonGrid = createSliceLayout<SlicePersonBioGridProps>(
  SlicePersonBioGrid, {
    verticalPadding: 'small',
    props: {
      showOrganisation: true,
    }
  }
);

export const SliceLayoutRestorationProjectGrid = createSliceLayout<RestorationProjectGridProps>(
  RestorationProjectGrid, {
    boundary: 'content-bleed',
  }
);

export const SliceLayoutQuestion = createSliceLayout<SliceQuestionProps>(
  SliceQuestion, {
    props: {
      iconComponent: KelpIcon,
    }
  }
);

export const SliceLayoutBannerTout = createSliceLayout<SliceBannerToutProps>(
  SliceBannerTout, {
    verticalPadding: 'large',
  }
);

export const SliceLayoutContent = createSliceLayout(
  SliceContent, {
    verticalPadding: 'small',
  }
);

export const SliceLayoutEntityStack = createSliceLayout(
  SliceEntityStackLink, {
    verticalPadding: 'none',
    boundary: 'none',
  }
);

export const SliceLayoutMarketMapPanel = createSliceLayout(
  SliceMarketMapPanel, {
    boundary: 'none',
    verticalPadding: 'panel',
    verticalBalanceDelta: 0,
    props: {
      useActivePage: true,
    }
  }
);

export const SliceLayoutRegionData = createSliceLayout(
  SliceRegionData, {
    verticalPadding: 'none',
    boundary: 'none',
  }
);

export const SliceLayoutAsideMapLink = createSliceLayout(
  SliceAsideMapLink, {
    verticalPadding: 'none',
    boundary: 'none',
  }
);

export const SliceLayoutContentPanel = createSliceLayout<SliceContentPanelProps>(
  SliceContentPanel, {
    boundary: 'none',
    verticalPadding: 'panel',
    verticalBalanceDelta: 0,
    props: {
      showIcon: false,
    }
  }
);

export const SliceLayoutEntityViewAsideMobile = createSliceLayout<SliceEntityViewAsideMobileProps>(
  SliceEntityViewAsideMobile, {
    boundary: 'none',
    verticalPadding: 'small',
    props: {
      dividerHeight: 150,
      expandedButtonOffset: 15,
      expandButtonLabel: 'View Metrics'
    }
  }
);

export const SliceLayoutViewIntro = createSliceLayout(
  SliceViewIntro, {
    boundary: 'none',
    verticalPadding: 'none',
  }
);

export const SliceLayoutRegionKeyMessage = createSliceLayout(
  SliceRegionKeyMessage, {
    verticalPadding: 'none',
    boundary: 'none',
    overlayColor: '#00000033',
  }
);